module.exports = __webpack_public_path__ + "static/media/job_manager.de6e9dbf.svg";